/**
 * How long each investigator milestone took, from the clock Brahma stamps on them.
 * Durations rather than wall-clock times: "how long" says where the minutes went.
 */

import type { InvestigationStep } from './review.store';

const at = (step: InvestigationStep): number | null => {
  if (!step.ts) return null;
  const parsed = Date.parse(step.ts);
  return Number.isNaN(parsed) ? null : parsed;
};

/** The gap to the next step; the last step has no successor and carries no duration. */
export const stepDurations = (steps: InvestigationStep[]): Array<number | null> =>
  steps.map((step, index) => {
    const start = at(step);
    const end = index + 1 < steps.length ? at(steps[index + 1]) : null;
    return start !== null && end !== null && end >= start ? end - start : null;
  });

/** Total wall time the trail covers, or null when the stamps cannot carry it. */
export const totalElapsed = (steps: InvestigationStep[]): number | null => {
  const first = steps.length ? at(steps[0]) : null;
  const last = steps.length ? at(steps[steps.length - 1]) : null;
  return first !== null && last !== null && last >= first ? last - first : null;
};
